import { Provider as ReduxProvider } from 'react-redux'
import { createRoot } from 'react-dom/client'
import React, { FC } from 'react'
import { ChakraProvider } from '@chakra-ui/react'
import * as Sentry from '@sentry/react'
import theme from '../styles'
import { store } from './state'
import { getSentryDsn } from '../env'
import { insertLogoInConsentIfWhitelabel } from '../consentbar/consent-bar'
import { getLocale } from '../i18n/locale'

document.documentElement.lang = getLocale()

const currentTheme = (domain: string) => {
  if (domain.includes('mobilesyrup.planhub.ca')) {
    return theme.mobilesyrup
  } else if (domain.includes('ratehub.planhub.ca')) {
    return theme.ratehub
  } else if (domain.includes('francoischarron.planhub.ca')) {
    return theme.francoischarron
  } else if (domain.includes('protegezvous.planhub.ca')) {
    return theme.protegezvous
  } else if (domain.includes('lactualite.planhub.ca')) {
    return theme.lactualite
  } else if (domain.includes('redflagdeals.planhub.ca')) {
    return theme.redflagdeals
  } else {
    return theme.default
  }
}

const domain = window.location.hostname

insertLogoInConsentIfWhitelabel()

Sentry.init({
  dsn: getSentryDsn(),
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
})

export const bootstrap = (App: FC) => {
  // Ensure any previously stored Chakra color mode is cleared so we start in light mode
  try {
    localStorage.removeItem('chakra-ui-color-mode')
    document.cookie = 'chakra-ui-color-mode=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;'
  } catch (e) {
    // ignore (SSR or browser restrictions)
  }

  const container = document.getElementById('root')!
  createRoot(container).render(
    <React.StrictMode>
      <ReduxProvider store={store}>
        <ChakraProvider theme={currentTheme(domain)}>
          <App />
        </ChakraProvider>
      </ReduxProvider>
    </React.StrictMode>,
  )
}
